import { render, staticRenderFns } from "./app-confirm.vue?vue&type=template&id=4dc3adcc&scoped=true&"
import script from "./app-confirm.vue?vue&type=script&lang=js&"
export * from "./app-confirm.vue?vue&type=script&lang=js&"
import style0 from "./app-confirm.vue?vue&type=style&index=0&id=4dc3adcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3adcc",
  null
  
)

export default component.exports